export const checkRequiredParams = (params) => {
  if (params.hasOwnProperty('agrmntAgreAt')) {
    if (!params.agrmntAgreAt || params.agrmntAgreAt?.length <= 0) {
      return false
    }
  }

  if (params.hasOwnProperty('agrmntAgreDe')) {
    if (!params.agrmntAgreDe || params.agrmntAgreDe?.length <= 0) {
      return false
    }
  }

  if (params.hasOwnProperty('ci')) {
    if (!params.ci || params.ci?.length <= 0) {
      return false
    }
  }

  if (params.hasOwnProperty('ecdwAdres')) {
    if (!params.ecdwAdres || params.ecdwAdres?.length <= 0) {
      return false
    }
  }

  if (params.hasOwnProperty('deviceId')) {
    if (!params.deviceId || params.deviceId?.length <= 0) {
      return false
    }
  }

  if (params.hasOwnProperty('moblphonNo')) {
    if (!params.moblphonNo || params.moblphonNo?.length <= 0) {
      return false
    }
  }

  if (params.hasOwnProperty('useAt')) {
    if (!params.useAt || params.useAt?.length <= 0) {
      return false
    }
  }

  if (params.hasOwnProperty('urlCode')) {
    if (!params.urlCode || params.urlCode?.length <= 0) {
      return false
    }
  }

  if (params.hasOwnProperty('birthDe')) {
    if (!params.birthDe || params.birthDe?.length <= 0) {
      return false
    }
  }

  if (params.hasOwnProperty('nm')) {
    if (!params.nm || params.nm?.length <= 0) {
      return false
    }
  }

  if (params.hasOwnProperty('ntvfrnrSeCode')) {
    if (!params.ntvfrnrSeCode || params.ntvfrnrSeCode?.length <= 0) {
      return false
    }
  }

  if (params.hasOwnProperty('sexdstnCode')) {
    if (!params.sexdstnCode || params.sexdstnCode?.length <= 0) {
      return false
    }
  }

  return true
}
